module.exports = __webpack_public_path__ + "img/popularity-unchecked-zh.0117672c.png";